import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface AddTraceToTableRequest {
  smart_table_id: string;
  sheet_id: string;
  trace_id: string;
  span_id?: string;
}

export interface AddTraceToTableResponse {
  success: boolean;
  rows_added: number;
  mode: "trace" | "span";
  error?: string;
  message?: string;
}

export const useAddTraceToTable = () => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const wid = Number(workspaceId);

  return useMutation<AddTraceToTableResponse, Error, AddTraceToTableRequest>(payload =>
    fetch(ENDPOINTS.add_trace_to_dataset(wid), {
      method: "POST",
      headers: jsonAuthHeaders(userToken),
      body: JSON.stringify(payload),
    }).then(handleResponse),
  );
};
